// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Button } from '@/components/ui/button';
// import { Card } from '@/components/ui/card';
// import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
// import { Input } from '@/components/ui/input';
// import { Label } from '@/components/ui/label';
// import { toast } from 'sonner';
// import { Plus, Building2, Edit, Trash2 } from 'lucide-react';

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const Businesses = () => {
//   const [businesses, setBusinesses] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [editingBusiness, setEditingBusiness] = useState(null);
//   const [formData, setFormData] = useState({
//     name: '',
//     logo: '',
//     color_theme: '#F57927',
//     address: '',
//     email: '',
//     phone: '',
//     tax_id: '',
//     gst_number: '',
//     parent_business_id: '',
//   });

//   useEffect(() => {
//     fetchBusinesses();
//   }, []);

//   const fetchBusinesses = async () => {
//     try {
//       const token = localStorage.getItem('token');
//       const response = await axios.get(`${API}/businesses`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setBusinesses(response.data);
//     } catch (error) {
//       toast.error('Failed to fetch businesses');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const token = localStorage.getItem('token');

//     try {
//       if (editingBusiness) {
//         await axios.put(`${API}/businesses/${editingBusiness.id}`, formData, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         toast.success('Business updated successfully');
//       } else {
//         await axios.post(`${API}/businesses`, formData, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         toast.success('Business created successfully');
//       }

//       setDialogOpen(false);
//       resetForm();
//       fetchBusinesses();
//     } catch (error) {
//       toast.error('Failed to save business');
//     }
//   };

//   const handleEdit = (business) => {
//     setEditingBusiness(business);
//     setFormData({
//       name: business.name,
//       logo: business.logo || '',
//       color_theme: business.color_theme,
//       address: business.address || '',
//       email: business.email || '',
//       phone: business.phone || '',
//       tax_id: business.tax_id || '',
//       gst_number: business.gst_number || '',
//       parent_business_id: business.parent_business_id || '',
//     });
//     setDialogOpen(true);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this business?')) return;

//     try {
//       const token = localStorage.getItem('token');
//       await axios.delete(`${API}/businesses/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       toast.success('Business deleted successfully');
//       fetchBusinesses();
//     } catch (error) {
//       toast.error('Failed to delete business');
//     }
//   };

//   const resetForm = () => {
//     setEditingBusiness(null);
//     setFormData({
//       name: '',
//       logo: '',
//       color_theme: '#F57927',
//       address: '',
//       email: '',
//       phone: '',
//       tax_id: '',
//       gst_number: '',
//       parent_business_id: '',
//     });
//   };

//   const mainBusinesses = businesses.filter(b => !b.parent_business_id);

//   return (
//     <div className="p-8 md:p-12" data-testid="businesses-page">
//       <div className="flex items-center justify-between mb-12">
//         <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Businesses</h1>
//         <Dialog open={dialogOpen} onOpenChange={(open) => { setDialogOpen(open); if (!open) resetForm(); }}>
//           <DialogTrigger asChild>
//             <Button className="gap-2" data-testid="create-business-button">
//               <Plus className="w-4 h-4" />
//               Add Business
//             </Button>
//           </DialogTrigger>
//           <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
//             <DialogHeader>
//               <DialogTitle>{editingBusiness ? 'Edit Business' : 'Create New Business'}</DialogTitle>
//             </DialogHeader>
//             <form onSubmit={handleSubmit} className="space-y-6 mt-4">
//               <div className="grid grid-cols-2 gap-4">
//                 <div className="col-span-2">
//                   <Label>Business Name *</Label>
//                   <Input
//                     value={formData.name}
//                     onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//                     required
//                     placeholder="Acme Corp"
//                     data-testid="business-name-input"
//                   />
//                 </div>
//                 <div className="col-span-2">
//                   <Label>Logo URL</Label>
//                   <Input
//                     value={formData.logo}
//                     onChange={(e) => setFormData({ ...formData, logo: e.target.value })}
//                     placeholder="https://example.com/logo.png"
//                   />
//                 </div>
//                 <div>
//                   <Label>Color Theme</Label>
//                   <Input
//                     type="color"
//                     value={formData.color_theme}
//                     onChange={(e) => setFormData({ ...formData, color_theme: e.target.value })}
//                   />
//                 </div>
//                 <div>
//                   <Label>Email</Label>
//                   <Input
//                     type="email"
//                     value={formData.email}
//                     onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//                     placeholder="contact@acme.com"
//                   />
//                 </div>
//                 <div>
//                   <Label>Phone</Label>
//                   <Input
//                     value={formData.phone}
//                     onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
//                     placeholder="+1 (555) 000-0000"
//                   />
//                 </div>
//                 <div>
//                   <Label>Tax ID</Label>
//                   <Input
//                     value={formData.tax_id}
//                     onChange={(e) => setFormData({ ...formData, tax_id: e.target.value })}
//                     placeholder="12-3456789"
//                   />
//                 </div>
//                 <div className="col-span-2">
//                   <Label>GST Number</Label>
//                   <Input
//                     value={formData.gst_number}
//                     onChange={(e) => setFormData({ ...formData, gst_number: e.target.value })}
//                     placeholder="GST123456789"
//                   />
//                 </div>
//                 <div className="col-span-2">
//                   <Label>Address</Label>
//                   <Input
//                     value={formData.address}
//                     onChange={(e) => setFormData({ ...formData, address: e.target.value })}
//                     placeholder="123 Main St, City, Country"
//                   />
//                 </div>
//                 <div className="col-span-2">
//                   <Label>Parent Business (for sub-products)</Label>
//                   <select
//                     className="w-full px-3 py-2 border border-input rounded-md bg-white"
//                     value={formData.parent_business_id}
//                     onChange={(e) => setFormData({ ...formData, parent_business_id: e.target.value })}
//                   >
//                     <option value="">None - Main Business</option>
//                     {mainBusinesses.map((biz) => (
//                       <option key={biz.id} value={biz.id}>{biz.name}</option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <div className="flex gap-3 justify-end">
//                 <Button type="button" variant="outline" onClick={() => { setDialogOpen(false); resetForm(); }}>
//                   Cancel
//                 </Button>
//                 <Button type="submit" data-testid="save-business-button">
//                   {editingBusiness ? 'Update' : 'Create'}
//                 </Button>
//               </div>
//             </form>
//           </DialogContent>
//         </Dialog>
//       </div>

//       {loading ? (
//         <div className="text-muted-foreground">Loading...</div>
//       ) : businesses.length === 0 ? (
//         <Card className="p-12 text-center border-dashed">
//           <Building2 className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
//           <p className="text-lg text-muted-foreground">No businesses yet. Create your first business!</p>
//         </Card>
//       ) : (
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {businesses.map((business) => (
//             <Card key={business.id} className="p-8 hover:shadow-hover transition-all border-border/50" data-testid={`business-card-${business.id}`}>
//               <div className="flex items-start justify-between mb-4">
//                 <div className="flex items-center gap-3">
//                   <div
//                     className="w-12 h-12 rounded-xl flex items-center justify-center"
//                     style={{ backgroundColor: `${business.color_theme}20` }}
//                   >
//                     {business.logo ? (
//                       <img src={business.logo} alt={business.name} className="w-8 h-8 object-contain" />
//                     ) : (
//                       <Building2 className="w-6 h-6" style={{ color: business.color_theme }} />
//                     )}
//                   </div>
//                   <div>
//                     <h3 className="font-bold text-lg">{business.name}</h3>
//                     {business.parent_business_id && (
//                       <span className="text-xs text-muted-foreground">Sub-product</span>
//                     )}
//                   </div>
//                 </div>
//               </div>
//               <div className="space-y-2 text-sm text-muted-foreground mb-6">
//                 {business.email && <p>{business.email}</p>}
//                 {business.phone && <p>{business.phone}</p>}
//                 {business.gst_number && <p>GST: {business.gst_number}</p>}
//               </div>
//               <div className="flex gap-2">
//                 <Button variant="outline" size="sm" onClick={() => handleEdit(business)} className="flex-1" data-testid={`edit-business-${business.id}`}>
//                   <Edit className="w-4 h-4 mr-2" />
//                   Edit
//                 </Button>
//                 <Button variant="destructive" size="sm" onClick={() => handleDelete(business.id)} data-testid={`delete-business-${business.id}`}>
//                   <Trash2 className="w-4 h-4" />
//                 </Button>
//               </div>
//             </Card>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Businesses;
// import React, { useState, useEffect } from 'react';
// // import axios from 'axios';
// import { Button } from '@/components/ui/button';
// import { Card } from '@/components/ui/card';
// import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
// import { Input } from '@/components/ui/input';
// import { Label } from '@/components/ui/label';
// import { toast } from 'sonner';
// import { Plus, Building2, Edit, Trash2 } from 'lucide-react';

// // ⬇️ NEW: Firebase imports
// import { db } from '../firebase';
// import {
//   collection,
//   getDocs,
//   addDoc,
//   updateDoc,
//   deleteDoc,
//   doc,
//   serverTimestamp,
// } from 'firebase/firestore';

// // const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const Businesses = () => {
//   const [businesses, setBusinesses] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [editingBusiness, setEditingBusiness] = useState(null);
//   const [formData, setFormData] = useState({
//     name: '',
//     logo: '',
//     color_theme: '#F57927',
//     address: '',
//     email: '',
//     phone: '',
//     tax_id: '',
//     gst_number: '',
//     parent_business_id: '',
//   });

//   useEffect(() => {
//     fetchBusinesses();
//   }, []);

//   const fetchBusinesses = async () => {
//     setLoading(true);
//     try {
//       // const token = localStorage.getItem('token');
//       // const response = await axios.get(`${API}/businesses`, {
//       //   headers: { Authorization: `Bearer ${token}` },
//       // });
//       // setBusinesses(response.data);

//       const snap = await getDocs(collection(db, 'businesses'));
//       const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
//       setBusinesses(list);
//     } catch (error) {
//       console.error(error);
//       toast.error('Failed to fetch businesses');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     // const token = localStorage.getItem('token');

//     try {
//       if (editingBusiness) {
//         // await axios.put(`${API}/businesses/${editingBusiness.id}`, formData, {
//         //   headers: { Authorization: `Bearer ${token}` },
//         // });

//         const ref = doc(db, 'businesses', editingBusiness.id);
//         await updateDoc(ref, {
//           ...formData,
//           updatedAt: serverTimestamp(),
//         });

//         toast.success('Business updated successfully');
//       } else {
//         // await axios.post(`${API}/businesses`, formData, {
//         //   headers: { Authorization: `Bearer ${token}` },
//         // });

//         await addDoc(collection(db, 'businesses'), {
//           ...formData,
//           createdAt: serverTimestamp(),
//         });

//         toast.success('Business created successfully');
//       }

//       setDialogOpen(false);
//       resetForm();
//       fetchBusinesses();
//     } catch (error) {
//       console.error(error);
//       toast.error('Failed to save business');
//     }
//   };

//   const handleEdit = (business) => {
//     setEditingBusiness(business);
//     setFormData({
//       name: business.name,
//       logo: business.logo || '',
//       color_theme: business.color_theme,
//       address: business.address || '',
//       email: business.email || '',
//       phone: business.phone || '',
//       tax_id: business.tax_id || '',
//       gst_number: business.gst_number || '',
//       parent_business_id: business.parent_business_id || '',
//     });
//     setDialogOpen(true);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this business?')) return;

//     try {
//       // const token = localStorage.getItem('token');
//       // await axios.delete(`${API}/businesses/${id}`, {
//       //   headers: { Authorization: `Bearer ${token}` },
//       // });

//       await deleteDoc(doc(db, 'businesses', id));

//       toast.success('Business deleted successfully');
//       fetchBusinesses();
//     } catch (error) {
//       console.error(error);
//       toast.error('Failed to delete business');
//     }
//   };

//   const resetForm = () => {
//     setEditingBusiness(null);
//     setFormData({
//       name: '',
//       logo: '',
//       color_theme: '#F57927',
//       address: '',
//       email: '',
//       phone: '',
//       tax_id: '',
//       gst_number: '',
//       parent_business_id: '',
//     });
//   };

//   const mainBusinesses = businesses.filter((b) => !b.parent_business_id);

//   return (
//     <div className="p-8 md:p-12" data-testid="businesses-page">
//       <div className="flex items-center justify-between mb-12">
//         <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Businesses</h1>
//         <Dialog
//           open={dialogOpen}
//           onOpenChange={(open) => {
//             setDialogOpen(open);
//             if (!open) resetForm();
//           }}
//         >
//           <DialogTrigger asChild>
//             <Button className="gap-2" data-testid="create-business-button">
//               <Plus className="w-4 h-4" />
//               Add Business
//             </Button>
//           </DialogTrigger>
//           <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
//             <DialogHeader>
//               <DialogTitle>{editingBusiness ? 'Edit Business' : 'Create New Business'}</DialogTitle>
//             </DialogHeader>
//             <form onSubmit={handleSubmit} className="space-y-6 mt-4">
//               <div className="grid grid-cols-2 gap-4">
//                 <div className="col-span-2">
//                   <Label>Business Name *</Label>
//                   <Input
//                     value={formData.name}
//                     onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//                     required
//                     placeholder="Acme Corp"
//                     data-testid="business-name-input"
//                   />
//                 </div>
//                 <div className="col-span-2">
//                   <Label>Logo URL</Label>
//                   <Input
//                     value={formData.logo}
//                     onChange={(e) => setFormData({ ...formData, logo: e.target.value })}
//                     placeholder="https://example.com/logo.png"
//                   />
//                 </div>
//                 <div>
//                   <Label>Color Theme</Label>
//                   <Input
//                     type="color"
//                     value={formData.color_theme}
//                     onChange={(e) => setFormData({ ...formData, color_theme: e.target.value })}
//                   />
//                 </div>
//                 <div>
//                   <Label>Email</Label>
//                   <Input
//                     type="email"
//                     value={formData.email}
//                     onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//                     placeholder="contact@acme.com"
//                   />
//                 </div>
//                 <div>
//                   <Label>Phone</Label>
//                   <Input
//                     value={formData.phone}
//                     onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
//                     placeholder="+1 (555) 000-0000"
//                   />
//                 </div>
//                 <div>
//                   <Label>Tax ID</Label>
//                   <Input
//                     value={formData.tax_id}
//                     onChange={(e) => setFormData({ ...formData, tax_id: e.target.value })}
//                     placeholder="12-3456789"
//                   />
//                 </div>
//                 <div className="col-span-2">
//                   <Label>GST Number</Label>
//                   <Input
//                     value={formData.gst_number}
//                     onChange={(e) => setFormData({ ...formData, gst_number: e.target.value })}
//                     placeholder="GST123456789"
//                   />
//                 </div>
//                 <div className="col-span-2">
//                   <Label>Address</Label>
//                   <Input
//                     value={formData.address}
//                     onChange={(e) => setFormData({ ...formData, address: e.target.value })}
//                     placeholder="123 Main St, City, Country"
//                   />
//                 </div>
//                 <div className="col-span-2">
//                   <Label>Parent Business (for sub-products)</Label>
//                   <select
//                     className="w-full px-3 py-2 border border-input rounded-md bg-white"
//                     value={formData.parent_business_id}
//                     onChange={(e) =>
//                       setFormData({ ...formData, parent_business_id: e.target.value })
//                     }
//                   >
//                     <option value="">None - Main Business</option>
//                     {mainBusinesses.map((biz) => (
//                       <option key={biz.id} value={biz.id}>
//                         {biz.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <div className="flex gap-3 justify-end">
//                 <Button
//                   type="button"
//                   variant="outline"
//                   onClick={() => {
//                     setDialogOpen(false);
//                     resetForm();
//                   }}
//                 >
//                   Cancel
//                 </Button>
//                 <Button type="submit" data-testid="save-business-button">
//                   {editingBusiness ? 'Update' : 'Create'}
//                 </Button>
//               </div>
//             </form>
//           </DialogContent>
//         </Dialog>
//       </div>

//       {loading ? (
//         <div className="text-muted-foreground">Loading...</div>
//       ) : businesses.length === 0 ? (
//         <Card className="p-12 text-center border-dashed">
//           <Building2 className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
//           <p className="text-lg text-muted-foreground">
//             No businesses yet. Create your first business!
//           </p>
//         </Card>
//       ) : (
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {businesses.map((business) => (
//             <Card
//               key={business.id}
//               className="p-8 hover:shadow-hover transition-all border-border/50"
//               data-testid={`business-card-${business.id}`}
//             >
//               <div className="flex items-start justify-between mb-4">
//                 <div className="flex items-center gap-3">
//                   <div
//                     className="w-12 h-12 rounded-xl flex items-center justify-center"
//                     style={{ backgroundColor: `${business.color_theme}20` }}
//                   >
//                     {business.logo ? (
//                       <img
//                         src={business.logo}
//                         alt={business.name}
//                         className="w-8 h-8 object-contain"
//                       />
//                     ) : (
//                       <Building2
//                         className="w-6 h-6"
//                         style={{ color: business.color_theme }}
//                       />
//                     )}
//                   </div>
//                   <div>
//                     <h3 className="font-bold text-lg">{business.name}</h3>
//                     {business.parent_business_id && (
//                       <span className="text-xs text-muted-foreground">Sub-product</span>
//                     )}
//                   </div>
//                 </div>
//               </div>
//               <div className="space-y-2 text-sm text-muted-foreground mb-6">
//                 {business.email && <p>{business.email}</p>}
//                 {business.phone && <p>{business.phone}</p>}
//                 {business.gst_number && <p>GST: {business.gst_number}</p>}
//               </div>
//               <div className="flex gap-2">
//                 <Button
//                   variant="outline"
//                   size="sm"
//                   onClick={() => handleEdit(business)}
//                   className="flex-1"
//                   data-testid={`edit-business-${business.id}`}
//                 >
//                   <Edit className="w-4 h-4 mr-2" />
//                   Edit
//                 </Button>
//                 <Button
//                   variant="destructive"
//                   size="sm"
//                   onClick={() => handleDelete(business.id)}
//                   data-testid={`delete-business-${business.id}`}
//                 >
//                   <Trash2 className="w-4 h-4" />
//                 </Button>
//               </div>
//             </Card>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Businesses;
import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Plus, Building2, Edit, Trash2 } from "lucide-react";

// ✅ Firebase Firestore only (NO STORAGE)
import { db } from "../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";

const Businesses = () => {
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingBusiness, setEditingBusiness] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    logo: "",
    color_theme: "#F57927",
    address: "",
    email: "",
    phone: "",
    tax_id: "",
    gst_number: "",
    parent_business_id: "",
    state: "",
    bank_name: "",
    bank_account_no: "",
    bank_ifsc: "",
    bank_account_holder: "",
  });

  useEffect(() => {
    fetchBusinesses();
  }, []);

  const fetchBusinesses = async () => {
    setLoading(true);
    try {
      const snap = await getDocs(collection(db, "businesses"));
      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setBusinesses(list);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch businesses");
    } finally {
      setLoading(false);
    }
  };

  // ✅ BASE64 IMAGE HANDLER
  const handleLogoUpload = (file) => {
    if (!file) return;

    if (file.size > 300 * 1024) {
      toast.error("Image must be under 300KB");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData((prev) => ({
        ...prev,
        logo: reader.result, // ✅ BASE64 STRING
      }));
    };
    reader.readAsDataURL(file);
  };

  // ✅ CREATE & UPDATE
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        name: formData.name,
        logo: formData.logo, // ✅ BASE64 SAVED
        color_theme: formData.color_theme,
        address: formData.address,
        email: formData.email,
        phone: formData.phone,
        tax_id: formData.tax_id,
        gst_number: formData.gst_number,
        parent_business_id: formData.parent_business_id,
        state: formData.state || "",
        bank_name: formData.bank_name || "",
        bank_account_no: formData.bank_account_no || "",
        bank_ifsc: formData.bank_ifsc || "",
        bank_account_holder: formData.bank_account_holder || "",
        updatedAt: serverTimestamp(),
      };

      if (editingBusiness) {
        const refDoc = doc(db, "businesses", editingBusiness.id);
        await updateDoc(refDoc, payload);
        toast.success("Business updated successfully");
      } else {
        await addDoc(collection(db, "businesses"), {
          ...payload,
          createdAt: serverTimestamp(),
        });
        toast.success("Business created successfully");
      }

      setDialogOpen(false);
      resetForm();
      fetchBusinesses();
    } catch (error) {
      console.error(error);
      toast.error("Failed to save business");
    }
  };

  // ✅ EDIT
  const handleEdit = (business) => {
    setEditingBusiness(business);
    setFormData({
      name: business.name,
      logo: business.logo || "",
      color_theme: business.color_theme,
      address: business.address || "",
      email: business.email || "",
      phone: business.phone || "",
      tax_id: business.tax_id || "",
      gst_number: business.gst_number || "",
      parent_business_id: business.parent_business_id || "",
      state: business.state || "",
      bank_name: business.bank_name || "",
      bank_account_no: business.bank_account_no || "",
      bank_ifsc: business.bank_ifsc || "",
      bank_account_holder: business.bank_account_holder || "",
    });
    setDialogOpen(true);
  };

  // ✅ DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this business?")) return;

    try {
      await deleteDoc(doc(db, "businesses", id));
      toast.success("Business deleted successfully");
      fetchBusinesses();
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete business");
    }
  };

  const resetForm = () => {
    setEditingBusiness(null);
    setFormData({
      name: "",
      logo: "",
      color_theme: "#F57927",
      address: "",
      email: "",
      phone: "",
      tax_id: "",
      gst_number: "",
      parent_business_id: "",
      state: "",
      bank_name: "",
      bank_account_no: "",
      bank_ifsc: "",
      bank_account_holder: "",
    });
  };

  const mainBusinesses = businesses.filter((b) => !b.parent_business_id);

  return (
    <div className="p-8 md:p-12">
      <div className="flex items-center justify-between mb-12">
        <h1 className="text-4xl font-bold">Businesses</h1>

        <Dialog open={dialogOpen} onOpenChange={(open) => {
          setDialogOpen(open);
          if (!open) resetForm();
        }}>
          <DialogTrigger asChild>
            <Button className="gap-2">
              <Plus className="w-4 h-4" />
              Add Business
            </Button>
          </DialogTrigger>

          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>
                {editingBusiness ? "Edit Business" : "Create New Business"}
              </DialogTitle>
            </DialogHeader>

            <form onSubmit={handleSubmit} className="space-y-6 mt-4">
              <div className="grid grid-cols-2 gap-4">

                {/* ✅ BUSINESS NAME */}
                <div className="col-span-2">
                  <Label>Business Name *</Label>
                  <Input
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    required
                  />
                </div>

                {/* ✅ BASE64 LOGO UPLOAD */}
                <div className="col-span-2">
                  <Label>Business Logo (Max 300KB)</Label>
                  <Input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleLogoUpload(e.target.files[0])}
                  />

                  {formData.logo && (
                    <img
                      src={formData.logo}
                      alt="Preview"
                      className="mt-2 w-20 h-20 object-contain border rounded"
                    />
                  )}
                </div>

                <div>
                  <Label>Color Theme</Label>
                  <Input
                    type="color"
                    value={formData.color_theme}
                    onChange={(e) =>
                      setFormData({ ...formData, color_theme: e.target.value })
                    }
                  />
                </div>

                <div>
                  <Label>Email</Label>
                  <Input
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                  />
                </div>

                <div>
                  <Label>Phone</Label>
                  <Input
                    value={formData.phone}
                    onChange={(e) =>
                      setFormData({ ...formData, phone: e.target.value })
                    }
                  />
                </div>

                <div>
                  <Label>Tax ID</Label>
                  <Input
                    value={formData.tax_id}
                    onChange={(e) =>
                      setFormData({ ...formData, tax_id: e.target.value })
                    }
                  />
                </div>

                <div>
                  <Label>GST Number</Label>
                  <Input
                    value={formData.gst_number}
                    onChange={(e) =>
                      setFormData({ ...formData, gst_number: e.target.value })
                    }
                  />
                </div>

                <div>
                  <Label>State</Label>
                  <Input
                    value={formData.state}
                    onChange={(e) =>
                      setFormData({ ...formData, state: e.target.value })
                    }
                    placeholder="e.g. 24-Gujarat"
                  />
                </div>

                <div className="col-span-2">
                  <Label>Address</Label>
                  <Input
                    value={formData.address}
                    onChange={(e) =>
                      setFormData({ ...formData, address: e.target.value })
                    }
                  />
                </div>

                {/* Bank Details Section */}
                <div className="col-span-2 border-t pt-4 mt-2">
                  <h4 className="font-semibold text-sm text-muted-foreground mb-3">Bank Details</h4>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <Label>Bank Name</Label>
                      <Input
                        value={formData.bank_name}
                        onChange={(e) =>
                          setFormData({ ...formData, bank_name: e.target.value })
                        }
                        placeholder="e.g. HDFC BANK"
                      />
                    </div>
                    <div>
                      <Label>Account Holder Name</Label>
                      <Input
                        value={formData.bank_account_holder}
                        onChange={(e) =>
                          setFormData({ ...formData, bank_account_holder: e.target.value })
                        }
                      />
                    </div>
                    <div>
                      <Label>Account Number</Label>
                      <Input
                        value={formData.bank_account_no}
                        onChange={(e) =>
                          setFormData({ ...formData, bank_account_no: e.target.value })
                        }
                      />
                    </div>
                    <div>
                      <Label>IFSC Code</Label>
                      <Input
                        value={formData.bank_ifsc}
                        onChange={(e) =>
                          setFormData({ ...formData, bank_ifsc: e.target.value })
                        }
                        placeholder="e.g. HDFC0009394"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-span-2">
                  <Label>Parent Business</Label>
                  <select
                    className="w-full px-3 py-2 border rounded"
                    value={formData.parent_business_id}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        parent_business_id: e.target.value,
                      })
                    }
                  >
                    <option value="">None - Main Business</option>
                    {mainBusinesses.map((biz) => (
                      <option key={biz.id} value={biz.id}>
                        {biz.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="flex justify-end gap-3">
                <Button variant="outline" type="button" onClick={() => setDialogOpen(false)}>
                  Cancel
                </Button>
                <Button type="submit">
                  {editingBusiness ? "Update" : "Create"}
                </Button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : businesses.length === 0 ? (
        <Card className="p-12 text-center">
          <Building2 className="mx-auto mb-4" />
          <p>No businesses yet.</p>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {businesses.map((business) => (
            <Card key={business.id} className="p-6">
              <div className="flex justify-between mb-4">
                <div className="flex gap-3">
                  <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center"
                    style={{ backgroundColor: `${business.color_theme}20` }}
                  >
                    {business.logo ? (
                      <img
                        src={business.logo}
                        className="w-8 h-8 object-contain"
                        alt=""
                      />
                    ) : (
                      <Building2 className="w-6 h-6" />
                    )}
                  </div>
                  <div>
                    <h3 className="font-bold">{business.name}</h3>
                    {business.parent_business_id && (
                      <span className="text-xs">Sub-product</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="text-sm mb-4">
                {business.email && <p>{business.email}</p>}
                {business.phone && <p>{business.phone}</p>}
                {business.gst_number && <p>GST: {business.gst_number}</p>}
              </div>

              <div className="flex gap-2">
                <Button size="sm" variant="outline" onClick={() => handleEdit(business)}>
                  <Edit className="w-4 h-4 mr-1" /> Edit
                </Button>
                <Button size="sm" variant="destructive" onClick={() => handleDelete(business.id)}>
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default Businesses;

